import { createModel } from "@/util/ModelUtil";

export default class InquiredLectureListModel {
  constructor(
    public data: InquiredLectureData[] = [],
    public last: boolean = true,
    public pageNumber: number = 0,
    public totalElementCount: number = 0
  ) {}

  public static create(
    data?: PageData<InquiredLectureData>
  ): InquiredLectureListModel {
    return createModel<InquiredLectureListModel>(
      InquiredLectureListModel,
      data
    );
  }
}
